module.exports = __webpack_public_path__ + "static/media/icon.41e23275.svg";